import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-koguiapi',
  template: `
    <p>
      koguiapi works!
    </p>
  `,
  styles: []
})
export class KoguiapiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
